import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// import * as QuestionnaireActions from '../../actions/questionnaire_actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { validate } from '../../validations';
import { ModalDialogCommon } from '../modal_dialog_common';

let Addoptions = React.createClass({
    getInitialState() {
        return {
            Okmessage: null,
        }
    },
    componentWillReceiveProps(nextProps) {

    },
    componentDidMount() {
        this.setState({ answer: this.props.answer })
        // this.props.Dispatch(QuestionnaireActions.questionnaire());
        // this.onOptionChange = this.props.onOptionChange || function () { };
    },
    onChangeHandler(e) {
        if (this.props.onOptionChange) {
            this.props.onOptionChange(this.refs.answer.value, this.props.id)
        }
        let value = e.target.value.trim();
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? e.target.className = 'update-mail' : e.target.parentElement.parentElement.className = 'error-border-bottom';
    },

    deletRow(e) {
        if (this.props.onDelete) {
            this.props.onDelete(this.props.id);
        }
    },
    remove_error(event) {
        event.target.parentElement.parentElement.className = '';
    },
    maxCharacterValue() {
        if (this.refs.answer.value.length === 140) {
            this.setState({
                Okmessage: "Max 140 characters reached.",

            })
            return false;
        }
    },
    closebox() {
        this.setState({ Okmessage: false, });
    },
    render() {
        return (
            <div className="questionnaire-delete">
                <ul>
                    {
                        this.state.answer &&
                        <li>
                            <span className="icon-add-more"></span>
                            <input className="update-mail" maxLength="140" placeholder="Option" type='text' ref='answer' onFocus={this.remove_error} onBlur={this.onChangeHandler} defaultValue={this.state.answer.name} onChange={this.maxCharacterValue}></input>
                            <button onClick={this.deletRow} className="pull-right notification-close">X</button>
                        </li>
                    }
                </ul>
                {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}
            </div>

        );
    }
});

let mapStateToProps = (state) => ({

});

let mapDispatchToProps = (dispatch) => ({
    // QuestionnaireActions: bindActionCreators(QuestionnaireActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Addoptions));




/** WEBPACK FOOTER **
 ** ./src/components/questionnaireScreen/addoption.js
 **/